import moment from 'moment';
import { trackingEvent } from '../../../../analytics';
import { AMPLITUDE_SERVICE } from '../../../../analytics/constants';
import { getBasicAmplitudEventProperties } from '../../../../analytics/utils';
import { getEndDateByGantt } from '../../../../utils/lookahead-common';
import {
  findDeepGetTask,
  updateAsyncTaskGanttV2,
  updateTaskDragHelperHack
} from '../../GanttVisualization.helper';
import taskDraftSir from '../../../../assets/img/newlookahead/sir/draftSirIcon.svg';
import taskDraftSir2 from '../../../../assets/img/newlookahead/sir/draftSirIcon2.svg';
import taskPendingSir from '../../../../assets/img/newlookahead/sir/taskPending.svg';

const UNFIT_START_MESSAGES = {
  early: (t) => t('early_start_conflict'),
  late: (t) => t('late_start_conflict'),
  pending: (t) => t('task_pending_sir_tooltip'),
  send: (t) => t('task_draft_sir_tooltip'),
  roleOutPermis: (t) => t('not_permissions_actions')
};
export const formatDate = (date, gantt) => {
  const format =
    gantt?.currentDateFormat?.replace('hh', 'HH') || 'YYYY-MM-DD HH:mm';
  return moment(date).format(format);
};

export const onChangeStart = (task, gantt, date) => {
  const taskFromLookahead = findDeepGetTask(window.activities, 'id', task.id);
  if (!taskFromLookahead) return null;

  gantt.updateCustomCommitmentPercentaje(taskFromLookahead, false);

  taskFromLookahead.start_date = date;
  getEndDateByGantt(taskFromLookahead, task.activityReference);

  const fieldsToUpdate = ['start_date', 'duration', 'end_date'];
  updateAsyncTaskGanttV2(taskFromLookahead, fieldsToUpdate, null, gantt);

  trackingEvent(
    'task_start_date_edition',
    {
      ...getBasicAmplitudEventProperties(),
      task_id: taskFromLookahead?.id,
      task_name: taskFromLookahead?.name,
      parent_activity_name: task.activityReference?.name,
      parent_activity_id: task.activityReference?.id
    },
    AMPLITUDE_SERVICE
  );
  updateTaskDragHelperHack(task.id, task);
};

export const getStartDateClass = (task) => {
  if (!task.unfitStartDate && !task.unfitEndDate) return '';
  return task.modificationSource === 'pending'
    ? 'start-date-pending'
    : 'start-date-draft';
};

export const calculateUnfitTooltipData = (task, t) => {
  let tooltip = '';
  const activityCurrent = window.ganttVisualization.getTask(
    task.activityReference?.id
  );
  const role = getCurrentUserRole();
  const roleOutPermis = ['subtrade', 'lastplanner', 'manager'].includes(role);
  const iconToShow = getIcon(task, activityCurrent);

  if (task.unfitStartDate) {
    const getMessage = UNFIT_START_MESSAGES[task.unfitStartDate];
    tooltip = getMessage ? getMessage(t) : '';
  }
  if (task.modificationSource === 'pending' && task.unfitStartDate) {
    tooltip = UNFIT_START_MESSAGES['pending'](t);
  }

  if (
    activityCurrent.requestState === 'pending' &&
    task.modificationSource !== 'pending'
  ) {
    tooltip = UNFIT_START_MESSAGES['send'](t);
  }

  if (roleOutPermis) {
    tooltip = UNFIT_START_MESSAGES['roleOutPermis'](t);
  }

  return {
    tooltip,
    iconToShow,
    isVisible: Boolean(task.unfitStartDate),
    unfitType:
      task.unfitStartDate ||
      (task.activityReference?.requestState === 'pending' ? 'pending' : '')
  };
};

const getIcon = (task, activityCurrent) => {
  if (task.modificationSource === 'pending') {
    return taskPendingSir;
  }
  if (activityCurrent?.requestState === 'pending') {
    return taskDraftSir2;
  }
  return taskDraftSir;
};

export const getCurrentUserRole = () => {
  const user = JSON.parse(localStorage.getItem('user'));

  return user?.role;
};
